import React, { useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
//Material
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
//Component
import { Modal } from "../../../stories/modal";
import { ReactTable } from "../../../stories/react-table";
import { API_URL } from "../../../utils/api-utils";
//Function
import * as api from "../api";
import * as alertDialog from "../../../utils/alert";
import { useSelectRowOpenModal } from "../../function-api/useSelectRowOpenModal";
import { getUserDataManagementHistoryColumns } from "../columns/user-data-management";

const rowStyle = (row, rowIndex) => {
  return { backgroundColor: row.STATUS_COLOR };
};

function UserDataImportHistoryModal(props) {
  const { open } = props;
  const { datalist, ...otherprops } = props;

  const method = useForm();
  useEffect(() => {
    if (!open) return;
    if (typeof Detail === "undefined") return;
  }, [datalist, open]);

  const {
    isOpen: openViewHistoryModal,
    onClose: onCloseViewHistory,
    Data: selectedViewHistory,
    handleClickRow: onClickRow,
  } = useSelectRowOpenModal();

  const onDownloadUserData = async (row) => {
    let param = { HISTORY_ID: row.HISTORY_ID };
    let res = await api.DownloadUserData(param);
    if (res?.FileName) {
      const url = `${API_URL.Loader}/` + res?.FileName;
      const fileName = `template-file-${row.TEMPLATE_ID}.csv`;

      // Create an invisible link element
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;

      // Append link to body and trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up the link element
      document.body.removeChild(link);
    } else {
      alertDialog.ErrorDialog("Error : File Not Found");
    }
  };

  const onViewHistory = (row) => {
    onClickRow(row);
  };

  return (
    <>
      <Modal
        {...otherprops}
        hiddenSave={true}
        title="Import History"
        maxWidth="lg"
      >
        <FormProvider {...method}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Box flexGrow={1} className="box-input">
                <ReactTable
                  otherprops
                  keyField="HISTORY_ID"
                  data={datalist}
                  columns={getUserDataManagementHistoryColumns(
                    onDownloadUserData,
                    onViewHistory
                  )}
                  showSearch={false}
                  rowStyle={rowStyle}
                />
              </Box>
            </Grid>
          </Grid>
        </FormProvider>
      </Modal>
      <Modal
        open={openViewHistoryModal}
        onClose={onCloseViewHistory}
        hiddenSave={true}
        title="Message"
        maxWidth="md"
      >
        {selectedViewHistory?.MESSAGE}
      </Modal>
    </>
  );
}
export default UserDataImportHistoryModal;
